module.exports = "<div class=\"header s12\">\n  <div class=\"last-activity\">\n    <p><b>ÚLTIMA ATUALIZAÇÃO EM:</b> {{ lastActivity }}</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/header/header.component.html
// module id = ./src/app/components/header/header.component.html
// module chunks = main